import React, { createContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { setLanguage, setBaseUrl } from './utils/api';
import { getCategories, getQuestions } from './utils/functions';

import Loader from './components/common/Loader';
import PageMain from './pages/PageMain';
import PageCategory from './pages/PageCategory';
import PageFaq from './pages/PageFaq';
import PageQuestion from './pages/PageQuestion';
import PageContact from './pages/PageContact';

// Create a Context
export const PagePropsContext = createContext();

const App = ({ config }) => {
  const { i18n } = useTranslation();

  const [categories, setCategories] = useState([]);
  const [questions, setQuestions] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedQuestion, setSelectedQuestion] = useState(null);

  const [showContact, setShowContact] = useState(false);
  const [showLoader, setShowLoader] = useState(true);

  const pageProps = {
    categories,
    questions,
    selectedCategory,
    setSelectedCategory,
    selectedQuestion,
    setSelectedQuestion,
    showContact,
    setShowContact,
  };

  // onReady
  useEffect(() => {
    // Set the default language in i18n
    i18n.changeLanguage(config.locale);

    // Set the default language in the API
    setLanguage(config.locale);
    setBaseUrl(config.url);

    // Load the data
    const initData = async () => {
      const categories = await getCategories();
      setCategories(categories);

      const questions = await getQuestions();
      setQuestions(questions);

      // Set the selected category and question
      if (config.question) {
        const question = questions.find(q => q.id === config.question);
        if (question) {
          const category = categories.find(c => c.id === question.category);
          if (category) {
            setSelectedCategory(categories.find(c => c.id === category.parent_category));
            setSelectedQuestion(question);
          }
        }
      }

      setShowLoader(false);
    }
    initData();
  }, [config, i18n]);

  return (
    <PagePropsContext.Provider value={pageProps}>
      <div className='nol_faq'>
        {showLoader && <Loader />}
        {showContact && <PageContact />}
        {!selectedCategory && <PageMain />}
        {(selectedCategory && selectedCategory.parent_category === null) && <PageCategory />}
        {(selectedCategory && selectedCategory.parent_category !== null && !selectedQuestion) && <PageFaq />}
        {selectedQuestion && <PageQuestion />}
      </div>
    </PagePropsContext.Provider>
  );
}

export default App;
